/**
 * Derive weight from variant name
 */
export function deriveWeight(variant: string): string {
  if (variant === 'thin') return '100';
  if (variant === 'extra-light' || variant === 'extralight') return '200';
  if (variant === 'light') return '300';
  if (variant === 'regular' || variant === 'normal') return '400';
  if (variant === 'medium') return '500';
  if (variant === 'semibold' || variant === 'semi-bold') return '600';
  if (variant === 'bold') return '700';
  if (variant === 'extra-bold' || variant === 'extrabold') return '800';
  if (variant === 'black') return '900';

  // Extract number from variant name (e.g., "700italic" -> "700")
  const match = variant.match(/\d+/);
  return match ? match[0] : '400';
}

/**
 * Derive style from variant name
 */
export function deriveStyle(variant: string): string {
  return variant.includes('italic') ? 'italic' : 'normal';
}

/**
 * Get font format from URL extension
 */
export function getFontFormat(url: string): string | null {
  if (!url) return null;

  const sanitizedUrl = url.split(/[?#]/)[0];
  const extension = sanitizedUrl.toLowerCase().split('.').pop();

  switch (extension) {
    case 'woff2':
      return 'woff2';
    case 'woff':
      return 'woff';
    case 'ttf':
      return 'truetype';
    case 'otf':
      return 'opentype';
    case 'eot':
      return 'embedded-opentype';
    default:
      return null;
  }
}
